export default "__VITE_ASSET__Ji763GZF__"